import React from 'react';

/**
 * The two ways this report emphasises a value mid-sentence: `Figure` for prose figures, `Mono` for ones
 * that should line up as numbers. Shared because every narrative section needs them and they were
 * drifting apart as local copies.
 */

export const Figure = ({ children }) => (
  <strong className='font-semibold text-gray-900'>{children}</strong>
);

export const Mono = ({ children }) => (
  <strong className='font-jetbrains-mono font-semibold text-gray-900'>{children}</strong>
);
